module.exports = __webpack_public_path__ + "static/media/shark.f06e3740.svg";